import type { Snippet } from 'svelte';

let _actions = $state<Snippet | null>(null);

export const subnav = {
	get actions(): Snippet | null {
		return _actions;
	},
	set actions(v: Snippet | null) {
		_actions = v;
	}
};
